import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  secondaryColor: PropTypes.string,
  size: PropTypes.number,
};

const CheckboxIcon = ({
  color = '#fff',
  secondaryColor = '#7ed321',
  size = 22,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    width={size}
    height={size}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <circle fill={secondaryColor} cx="11" cy="11" r="11" />
      <path
        fill={color}
        d="M14.167 7.6h-.3l-4.12 4.12L7.82 9.795h-.3L6 11.304v.3L9.597 15.2h.3l5.78-5.78v-.3z"
      />
    </g>
  </svg>
);

CheckboxIcon.propTypes = propTypes;

export default CheckboxIcon;
